import * as am5 from "@amcharts/amcharts5";

 // Set data
 export const SUNBURST_DATA = [{
  name: "GLOBAL",
  nodeSettings: { fill: am5.color(0x000000) },
  children: [{
    name: "Operations",
    nodeSettings: { fill: am5.color("#D92D20") },
    children: [
      {
        name: "Supply Chain Disruptions",
        nodeSettings: { fill: am5.color("#1A1A24") },
        children: [
          { nodeSettings: { fill: am5.color(3026492) }, value: 2 },
          { nodeSettings: { fill: am5.color(1710628) }, value: 1 },
          { nodeSettings: { fill: am5.color(3026492) }, value: 3 },
          { nodeSettings: { fill: am5.color(1710628) }, value: 2 },
        ],
      },
      {
        name: "Supply Chain Disruptions1",
        nodeSettings: { fill: am5.color(1710628) },
        children: [
          { nodeSettings: { fill: am5.color(3026492) }, value: 3 },
          { nodeSettings: { fill: am5.color(1710628) }, value: 2 },
        ]
      },
      {
        name: "Supply Chain Disruptions3",
        nodeSettings: { fill: am5.color(12434885) },
        children: [
          { nodeSettings: { fill: am5.color(3026492) }, value: 5 },
          { nodeSettings: { fill: am5.color(1710628) }, value: 1 },
        ]
      },
      {
        name: "Supply Chain Disruptions4",
        nodeSettings: { fill: am5.color(3026492) },
        children: [
          { nodeSettings: { fill: am5.color(3026492) }, value: 2 },
          { nodeSettings: { fill: am5.color(1710628) }, value: 5 },
          { nodeSettings: { fill: am5.color(3026492) }, value: 3 },
          { nodeSettings: { fill: am5.color(1710628) }, value: 2 },
        ]
      },
      {
        name: "Supply Chain Disruptions5",
        nodeSettings: { fill: am5.color(16448252) }, children: [
          { nodeSettings: { fill: am5.color(3026492) }, value: 4 },
          { nodeSettings: { fill: am5.color(1710628) }, value: 2 },
        ]
      },
      {
        name: "Supply Chain Disruptions6",
        nodeSettings: { fill: am5.color(3026492) },
        children: [
          { nodeSettings: { fill: am5.color(3026492) }, value: 2 },
          { nodeSettings: { fill: am5.color(1710628) }, value: 5 },
        ]
      },
    ],
  }, {
    name: "REGULATIONS",
    nodeSettings: { fill: am5.color("#1A1A24") },
    children: [
      {
        nodeSettings: { fill: am5.color(12434885) },
        children: [
          { nodeSettings: { fill: am5.color(3026492) }, value: 1 },
          { nodeSettings: { fill: am5.color(1710628) }, value: 4 },
        ]
      },
      {
        nodeSettings: { fill: am5.color(3026492) },
        children: [
          { nodeSettings: { fill: am5.color(3026492) }, value: 2 },
          { nodeSettings: { fill: am5.color(1710628) }, value: 3 },
        ]
      },
      {
        nodeSettings: { fill: am5.color(16448252) }, children: [
          { nodeSettings: { fill: am5.color(3026492) }, value: 2 },
          { nodeSettings: { fill: am5.color(1710628) }, value: 4 },
        ]
      },
    ],
  }, {
    name: "TAX",
    nodeSettings: { fill: am5.color("#3A3A4A") },
    children: [
      {
        nodeSettings: { fill: am5.color(3026492) },
        children: [
          { nodeSettings: { fill: am5.color(3026492) }, value: 1 },
          { nodeSettings: { fill: am5.color(1710628) }, value: 5 },
        ]
      },
      {
        nodeSettings: { fill: am5.color(1710628) },
        children: [
          { nodeSettings: { fill: am5.color(3026492) }, value: 1 },
          { nodeSettings: { fill: am5.color(1710628) }, value: 4 },
        ]
      },
      {
        nodeSettings: { fill: am5.color(12434885) },
        children: [
          { nodeSettings: { fill: am5.color(3026492) }, value: 1 },
          { nodeSettings: { fill: am5.color(1710628) }, value: 1 },
        ]
      },
      {
        nodeSettings: { fill: am5.color(3026492) },
        children: [
          { nodeSettings: { fill: am5.color(3026492) }, value: 1 },
          { nodeSettings: { fill: am5.color(1710628) }, value: 3 },
        ]
      },
      {
        nodeSettings: { fill: am5.color(16448252) }, children: [
          { nodeSettings: { fill: am5.color(3026492) }, value: 4 },
          { nodeSettings: { fill: am5.color(1710628) }, value: 1 },
        ]
      },
      {
        nodeSettings: { fill: am5.color(16448252) }, children: [
          { nodeSettings: { fill: am5.color(3026492) }, value: 4 },
          { nodeSettings: { fill: am5.color(1710628) }, value: 1 },
        ]
      },
    ],
  }, {
    name: "CYBER",
    nodeSettings: { fill: am5.color("#1A1A24") },
    children: [
      {
        nodeSettings: { fill: am5.color(3026492) },
        children: [
          { nodeSettings: { fill: am5.color(3026492) }, value: 3 },
          { nodeSettings: { fill: am5.color(1710628) }, value: 2 },
        ]
      },
      {
        nodeSettings: { fill: am5.color(1710628) },
        children: [
          { nodeSettings: { fill: am5.color(3026492) }, value: 4 },
          { nodeSettings: { fill: am5.color(1710628) }, value: 1 },
        ]
      },
      {
        nodeSettings: { fill: am5.color(12434885) },
        children: [
          { nodeSettings: { fill: am5.color(3026492) }, value: 1 },
          { nodeSettings: { fill: am5.color(1710628) }, value: 5 },
        ]
      },
      {
        nodeSettings: { fill: am5.color(3026492) },
        children: [
          { nodeSettings: { fill: am5.color(3026492) }, value: 3 },
          { nodeSettings: { fill: am5.color(1710628) }, value: 2 },
        ]
      },
      {
        nodeSettings: { fill: am5.color(16448252) }, children: [
          { nodeSettings: { fill: am5.color(3026492) }, value: 1 },
          { nodeSettings: { fill: am5.color(1710628) }, value: 4 },
        ]
      },
      {
        nodeSettings: { fill: am5.color(16448252) }, children: [
          { nodeSettings: { fill: am5.color(3026492) }, value: 1 },
          { nodeSettings: { fill: am5.color(1710628) }, value: 4 },
        ]
      }, {
        nodeSettings: { fill: am5.color(16448252) }, children: [
          { nodeSettings: { fill: am5.color(3026492) }, value: 1 },
          { nodeSettings: { fill: am5.color(1710628) }, value: 4 },
        ]
      },
      {
        nodeSettings: { fill: am5.color(16448252) }, children: [
          { nodeSettings: { fill: am5.color(3026492) }, value: 1 },
          { nodeSettings: { fill: am5.color(1710628) }, value: 4 },
        ]
      },
    ],
  }, {
    name: "ENVIRONMENT",
    nodeSettings: { fill: am5.color("#BDBDC5"), color: am5.color(0x000000) },
    children: [
      {
        nodeSettings: { fill: am5.color(3026492) },
        children: [
          { nodeSettings: { fill: am5.color(3026492) }, value: 1 },
          { nodeSettings: { fill: am5.color(1710628) }, value: 3 },
        ]
      },
      {
        nodeSettings: { fill: am5.color(1710628) },
        children: [
          { nodeSettings: { fill: am5.color(3026492) }, value: 4 },
          { nodeSettings: { fill: am5.color(1710628) }, value: 2 },
        ]
      },
      {
        nodeSettings: { fill: am5.color(12434885) },
        children: [
          { nodeSettings: { fill: am5.color(3026492) }, value: 2 },
          { nodeSettings: { fill: am5.color(1710628) }, value: 2 },
        ]
      },
      {
        nodeSettings: { fill: am5.color(3026492) },
        children: [
          { nodeSettings: { fill: am5.color(3026492) }, value: 1 },
          { nodeSettings: { fill: am5.color(1710628) }, value: 3 },
        ]
      },
    ],
  }, {
    name: "FINANCIAL",
    nodeSettings: { fill: am5.color("#1A1A24") },
    children: [
      {
        nodeSettings: { fill: am5.color(3026492) },
        children: [
          { nodeSettings: { fill: am5.color(3026492) }, value: 4 },
          { nodeSettings: { fill: am5.color(1710628) }, value: 1 },
        ]
      },
      {
        nodeSettings: { fill: am5.color(1710628) },
        children: [
          { nodeSettings: { fill: am5.color(3026492) }, value: 1 },
          { nodeSettings: { fill: am5.color(1710628) }, value: 5 },
        ]
      },
      {
        nodeSettings: { fill: am5.color(12434885) },
        children: [
          { nodeSettings: { fill: am5.color(3026492) }, value: 5 },
          { nodeSettings: { fill: am5.color(1710628) }, value: 1 },
        ]
      },
      {
        nodeSettings: { fill: am5.color(3026492) },
        children: [
          { nodeSettings: { fill: am5.color(3026492) }, value: 2 },
          { nodeSettings: { fill: am5.color(1710628) }, value: 3 },
        ]
      },
      {
        nodeSettings: { fill: am5.color(16448252) }, children: [
          { nodeSettings: { fill: am5.color(3026492) }, value: 2 },
          { nodeSettings: { fill: am5.color(1710628) }, value: 5 },
        ]
      },
      {
        nodeSettings: { fill: am5.color(16448252) }, children: [
          { nodeSettings: { fill: am5.color(3026492) }, value: 2 },
          { nodeSettings: { fill: am5.color(1710628) }, value: 5 },
        ]
      },
      {
        nodeSettings: { fill: am5.color(16448252) }, children: [
          { nodeSettings: { fill: am5.color(3026492) }, value: 2 },
          { nodeSettings: { fill: am5.color(1710628) }, value: 5 },
        ]
      },
      {
        nodeSettings: { fill: am5.color(16448252) }, children: [
          { nodeSettings: { fill: am5.color(3026492) }, value: 2 },
          { nodeSettings: { fill: am5.color(1710628) }, value: 5 },
        ]
      },
      {
        nodeSettings: { fill: am5.color(16448252) }, children: [
          { nodeSettings: { fill: am5.color(3026492) }, value: 2 },
          { nodeSettings: { fill: am5.color(1710628) }, value: 5 },
        ]
      },
    ],
  }, {
    name: "HUMAN RESOURCES",
    nodeSettings: { fill: am5.color("#2E2E3C") },
    children: [
      {
        nodeSettings: { fill: am5.color(3026492) },
        children: [
          { nodeSettings: { fill: am5.color(3026492) }, value: 4 },
          { nodeSettings: { fill: am5.color(1710628) }, value: 1 },
        ]
      },
      {
        nodeSettings: { fill: am5.color(1710628) },
        children: [
          { nodeSettings: { fill: am5.color(3026492) }, value: 1 },
          { nodeSettings: { fill: am5.color(1710628) }, value: 4 },
        ]
      },
      {
        nodeSettings: { fill: am5.color(12434885) },
        children: [
          { nodeSettings: { fill: am5.color(3026492) }, value: 1 },
          { nodeSettings: { fill: am5.color(1710628) }, value: 5 },
        ]
      },
      {
        nodeSettings: { fill: am5.color(3026492) },
        children: [
          { nodeSettings: { fill: am5.color(3026492) }, value: 1 },
          { nodeSettings: { fill: am5.color(1710628) }, value: 2 },
        ]
      },
      {
        nodeSettings: { fill: am5.color(16448252) }, children: [
          { nodeSettings: { fill: am5.color(3026492) }, value: 1 },
          { nodeSettings: { fill: am5.color(1710628) }, value: 3 },
        ]
      },
    ],
  }]
}];